import { Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TopbarMenu from '../topbar/TopbarMenu';
import ApiMigrations from './ApiMigrations';
import MonitorLogsTable from './MonitorLogsTable';
import MainLayoutStyles from '../../styles/MainLayoutStyle';
import SidebarMenu from '../sidebar/SidebarMenu';
import RightSideLeaderboard from '../leaderboard/components/RightSideLeaderboard';
import RightSideInapp from '../inapp/RightSideInapp';
import SideBarListBadge from '../sidebar/SideBarListBadge';
import SidebarListInapp from '../inapp/SidebarListInapp';
import BadgeContent from '../badge/BadgeContent';
import LeftbarAuthClient from '../AuthClient/LeftbarAuthClient';
import LeftSideLeaderboard from '../leaderboard/components/LeftSideLeaderboard';
import LeftSideInapp from '../inapp/LeftSideInapp';
import SideBarListAuth from '../sidebar/SideBarListAuth';
import {
  getCustomGroupDetails,
  getRulesDetails,
  setCustomGroupsListData,
  setInappData,
  setRulesListData,
  setContestData,
  showProgress,
  setNetworkPartnerList,
  getContestDetails,
  setRnpList,
  getRnpDetails,
  getRnpSelectedType,
} from '../../redux/actions/DealershipActions';
import Service from '../../apis/service';
import { ErrorToast, getFilteredList } from '../utils/Utils';
import Topbar from '../topbar/Topbar';
import SidebarListCustomGroups from '../customGroups/SidebarListCustomGroups';
import CustomGroupMainContent from '../customGroups/CustomGroupMainContent';
import RulesMainContent from '../rules/RulesMainContent';
import SidebarListRules from '../rules/SidebarListRules';
import { apiEndpoints } from '../../constants/apiEndpoints';
import LeftSideContest from '../contests/components/LeftSideContest';
import RightSideContest from '../contests/components/RightSideContest';
import SidebarListContest from '../contests/components/SidebarListContest';
import SearchBox from '../shared/SearchBox';
import SidebarListRnp from '../rnp/components/SidebarListRnp';
import MainContainer from '../rnp/components/MainContainer';
import SidebarLeaderboard from '../leaderboard/components/SidebarLeaderboard';
import useFetchList from '../leaderboard/hooks/useFetchList';
import ZombieTable from './ZombieTable';
import DealershipListTable from './DealershipListTable'; // eslint-disable-line no-unused-vars
import SidebarListAdminUsers from '../adminUsers/components/SidebarListAdminUsers';
import AdminUsersMainContent from '../adminUsers/components/AdminUsersMainContent';
import useAdminUsers from '../adminUsers/hooks/useAdminUsers';

const DevPanelLayout = () => {
  const classes = MainLayoutStyles();
  const dispatch = useDispatch();
  const { getList } = useFetchList();
  const { getList: getAdminUsersList } = useAdminUsers();

  const devTabID = useSelector((state) => state.getDEVTabId);
  const mainTabID = useSelector((state) => state.getMainTabID);
  const authList = useSelector((state) => state.getAuthClientList.authClientList);
  const leaderboardList = useSelector((state) => state?.getLeaderboard?.leaderboardList);
  const contestList = useSelector((state) => state.contestData.contestList);
  const inappList = useSelector((state) => state.inappData.inappList);
  const customGroupList = useSelector((state) => state.customGroupsData.customGroupsList);
  const rulesList = useSelector((state) => state.rulesData.rulesList);
  const rnpList = useSelector((state) => state.rnpData.rnpList);
  const selectedType = useSelector((state) => state.rnpData.selectedType);
  const adminUsersList = useSelector((state) => state.adminUsersData.list);

  const [searchAdminVal, setSearchAdminVal] = useState('');
  const [filterAdminArray, setFilterAdminArray] = useState([]);
  const [searchAVal, setSearchAVal] = useState('');
  const [searchRnpVal, setSearchRnpVal] = useState('');
  const [searchLVal, setSearchLVal] = useState('');
  const [searchContestVal, setSearchContestVal] = useState('');
  const [searchIVal, setSearchIVal] = useState('');
  const [searchCVal, setSearchCVal] = useState('');
  const [searchRVal, setSearchRVal] = useState('');

  const [filterAArray, setFilterAArray] = useState([]);
  const [filterRnpArray, setFilterRnpArray] = useState([]);
  const [filterLArray, setFilterLArray] = useState([]);
  const [filterIArray, setFilterIArray] = useState([]);
  const [filterCArray, setFilterCArray] = useState([]);
  const [filterRArray, setFilterRArray] = useState([]);
  const [filterContestArray, setFilterContestArray] = useState([]);

  useEffect(() => {
    setSearchAVal('');
    setFilterAArray(authList);
  }, [authList]);

  const fetchRnpDataByType = useCallback(
    async (type) => {
      const res = rnpList?.filter((item) => item?.type === type);
      dispatch(getRnpDetails(...res));
    },
    [dispatch, rnpList],
  );

  useEffect(() => {
    setSearchRnpVal('');
    const temp = rnpList?.map((item) => ({ name: item?.type, issuerCount: item?.partners?.length }));
    setFilterRnpArray(temp);
    if (selectedType) {
      fetchRnpDataByType(selectedType);
    } else {
      fetchRnpDataByType(temp[0]?.name);
    }
  }, [fetchRnpDataByType, rnpList, selectedType]);

  useEffect(() => {
    setSearchLVal('');
    setFilterLArray(leaderboardList);
  }, [leaderboardList]);

  useEffect(() => {
    setSearchContestVal('');
    setFilterContestArray(contestList);
  }, [contestList]);

  useEffect(() => {
    setSearchIVal('');
    setFilterIArray(inappList);
  }, [inappList]);

  useEffect(() => {
    setSearchCVal('');
    setFilterCArray(customGroupList);
  }, [customGroupList]);

  useEffect(() => {
    setSearchRVal('');
    setFilterRArray(rulesList);
  }, [rulesList]);

  useEffect(() => {
    setSearchAdminVal('');
    setFilterAdminArray(adminUsersList);
  }, [adminUsersList]);

  useEffect(() => {
    if (mainTabID === 8) {
      getList();
    }
    if (mainTabID === 9) {
      fetchInappData();
    }
    if (mainTabID === 10) {
      fetchCustomGroupsData();
    }
    if (mainTabID === 11) {
      fetchRulesData();
    }
    if (mainTabID === 19) {
      fetchContestsData();
      fetchNetworkPartnerList();
    }
    if (mainTabID === 21) {
      dispatch(getRnpSelectedType(null));
      fetchRnpList();
    }
    if (mainTabID === 23) {
      getAdminUsersList();
    }
  }, [mainTabID]);

  const handleSearchAuth = (e) => {
    const input = e.target.value;
    setSearchAVal(input);
    const filteredAArray = input
      ? authList.filter((item) => item.name.toLowerCase().includes(input.toLowerCase()))
      : authList;
    setFilterAArray(filteredAArray);
  };

  const handleSearchLeaderboard = (e) => {
    const input = e.target.value;
    setSearchLVal(input);
    const filteredLArray = input
      ? leaderboardList.filter((item) => item.name.toLowerCase().includes(input.toLowerCase()))
      : leaderboardList;
    setFilterLArray(filteredLArray);
  };

  const handleSearchContest = (e) => {
    const input = e.target.value;
    setSearchContestVal(input);
    const filteredContestArray = input
      ? contestList.filter((item) => item.name.toLowerCase().includes(input.toLowerCase()))
      : contestList;
    setFilterContestArray(filteredContestArray);
  };
  const handleSearchRnp = (e) => {
    const input = e.target.value;
    setSearchRnpVal(input);
    const filteredRnpArray = input
      ? rnpList.filter((item) => item.type.toLowerCase().includes(input.toLowerCase()))
      : rnpList;
    const temp = filteredRnpArray?.map((item) => ({ name: item?.type, issuerCount: item?.partners?.length }));
    setFilterRnpArray(temp);
  };

  const handleSearchInApp = (e) => {
    const input = e.target.value;
    setSearchIVal(input);
    const filteredIArray = input
      ? inappList.filter((item) => item.title.toLowerCase().includes(input.toLowerCase()))
      : inappList;
    setFilterIArray(filteredIArray);
  };

  const handleSearchCustomGroups = (e) => {
    const input = e.target.value;
    setSearchCVal(input);
    const filteredCArray = input
      ? customGroupList.filter((item) => item.name.toLowerCase().includes(input.toLowerCase()))
      : customGroupList;
    setFilterCArray(filteredCArray);
  };

  const handleSearchRules = (e) => {
    const input = e.target.value;
    setSearchRVal(input);
    const filteredRArray = input
      ? rulesList.filter((item) => item.name.toLowerCase().includes(input.toLowerCase()))
      : rulesList;
    setFilterRArray(filteredRArray);
  };

  const handleSearchAdminUsers = (e) => {
    const input = e.target.value;
    setSearchAdminVal(input);
    setFilterAdminArray(getFilteredList(adminUsersList, input, ['firstName', 'lastName', 'email']));
  };

  const fetchContestDataById = async (id) => {
    dispatch(showProgress(true));
    await Service.get(apiEndpoints.CON_DETAILS.replace('ID', id))
      .then((response) => {
        dispatch(getContestDetails(response));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };

  const fetchContestsData = async (id) => {
    dispatch(showProgress(true));
    await Service.get(apiEndpoints.CON_FETCH)
      .then((response) => {
        dispatch(setContestData(response, id));
        fetchContestDataById(response[0]?.id);
      })
      .catch((error) => {
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };
  const fetchNetworkPartnerList = async () => {
    dispatch(showProgress(true));
    await Service.get(apiEndpoints.CON_NET_PARTNER_LIST)
      .then((res) => {
        dispatch(setNetworkPartnerList(res));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };

  const fetchRnpList = async () => {
    dispatch(showProgress(true));
    await Service.get(apiEndpoints.GET_RNP_LIST)
      .then((res) => {
        dispatch(setRnpList(res));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };

  const fetchInappData = async (id) => {
    dispatch(showProgress(true));
    await Service.get(apiEndpoints.INAPP_FETCH)
      .then((response) => {
        dispatch(setInappData(response, id));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };

  const fetchCustomGroupsData = async () => {
    dispatch(showProgress(true));
    await Service.get(apiEndpoints.CG_LIST)
      .then((response) => {
        dispatch(setCustomGroupsListData(response));
        dispatch(getCustomGroupDetails(response[0]?.id));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };

  const fetchRulesData = async () => {
    dispatch(showProgress(true));
    await Service.get(apiEndpoints.RULES_FETCH)
      .then((response) => {
        dispatch(setRulesListData(response));
        dispatch(getRulesDetails(response[0]?.id));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };

  const getSearchComponent = () => {
    switch (mainTabID) {
      case 6:
        return (
          <Grid item>
            <SearchBox
              handleSearchChange={handleSearchAuth}
              searchVal={searchAVal}
              placeholder="Search Auth"
              filterCondition
            />
          </Grid>
        );
      case 8:
        return (
          <Grid item>
            <SearchBox
              handleSearchChange={handleSearchLeaderboard}
              searchVal={searchLVal}
              placeholder="Search Leaderboard"
              filterCondition
            />
          </Grid>
        );
      case 9:
        return (
          <Grid item>
            <SearchBox
              handleSearchChange={handleSearchInApp}
              searchVal={searchIVal}
              placeholder="Search InApp"
              filterCondition
            />
          </Grid>
        );
      case 10:
        return (
          <Grid item>
            <SearchBox
              handleSearchChange={handleSearchCustomGroups}
              searchVal={searchCVal}
              placeholder="Search Custom Group"
              filterCondition
            />
          </Grid>
        );
      case 11:
        return (
          <Grid item>
            <SearchBox
              handleSearchChange={handleSearchRules}
              searchVal={searchRVal}
              placeholder="Search Rules"
              filterCondition
            />
          </Grid>
        );

      case 19:
        return (
          <Grid item>
            <SearchBox
              handleSearchChange={handleSearchContest}
              searchVal={searchContestVal}
              placeholder="Search Contest"
              filterCondition
            />
          </Grid>
        );
      case 21:
        return (
          <SearchBox
            handleSearchChange={handleSearchRnp}
            searchVal={searchRnpVal}
            placeholder="Search RNP"
            filterCondition
          />
        );
      case 23:
        return (
          <Grid item>
            <SearchBox
              handleSearchChange={handleSearchAdminUsers}
              searchVal={searchAdminVal}
              placeholder="Search Admin Users"
              filterCondition
            />
          </Grid>
        );
      default:
        return '';
    }
  };

  const getSidebarWithSearchContent = () => {
    switch (mainTabID) {
      case 6:
        return <SideBarListAuth filterArray={filterAArray} />;
      case 8:
        return <SidebarLeaderboard filterArray={filterLArray} />;
      case 9:
        return <SidebarListInapp fetchData={fetchInappData} filterArray={filterIArray} />;
      case 10:
        return <SidebarListCustomGroups fetchData={fetchCustomGroupsData} filterArray={filterCArray} />;
      case 11:
        return <SidebarListRules fetchData={fetchRulesData} filterArray={filterRArray} />;
      case 19:
        return (
          <SidebarListContest
            fetchData={fetchContestsData}
            filterArray={filterContestArray}
            handleListItemClick={fetchContestDataById}
          />
        );
      case 21:
        return (
          <SidebarListRnp
            fetchData={fetchRnpList}
            filterArray={filterRnpArray}
            handleListItemClick={fetchRnpDataByType}
          />
        );
      case 23:
        return <SidebarListAdminUsers filterArray={filterAdminArray} />;
      default:
        return '';
    }
  };

  const getSidebarWithoutSearchContent = () => {
    switch (mainTabID) {
      case 7:
        return <SideBarListBadge />;
      default:
        return '';
    }
  };

  const getSidebar = () => {
    switch (mainTabID) {
      case 7:
        return (
          <Grid item className={classes.sidebar2} id="dose_sidebar_id">
            {getSidebarWithoutSearchContent()}
          </Grid>
        );
      case 6:
        return (
          <Grid item className={classes.sidebar3} id="sidebar_id">
            {getSidebarWithSearchContent()}
          </Grid>
        );
      case 8:
        return (
          <Grid item className={classes.sidebar3} id="leaderboard_sidebar_id">
            {getSidebarWithSearchContent()}
          </Grid>
        );
      case 9:
        return (
          <Grid item className={classes.sidebar3} id="inapp_sidebar_id">
            {getSidebarWithSearchContent()}
          </Grid>
        );
      case 10:
        return (
          <Grid item className={classes.sidebar3} id="inapp_sidebar_id">
            {getSidebarWithSearchContent()}
          </Grid>
        );
      case 11:
        return (
          <Grid item className={classes.sidebar3} id="inapp_sidebar_id">
            {getSidebarWithSearchContent()}
          </Grid>
        );
      case 19:
        return (
          <Grid item className={classes.sidebar3} id="contest_sidebar_id">
            {getSidebarWithSearchContent()}
          </Grid>
        );
      case 21:
        return (
          <Grid item className={classes.sidebar3} id="rnp_sidebar_id">
            {getSidebarWithSearchContent()}
          </Grid>
        );
      case 23:
        return (
          <Grid item className={classes.sidebar3} id="admin_users_sidebar_id">
            {getSidebarWithSearchContent()}
          </Grid>
        );
      default:
        return '';
    }
  };

  const getLeftContent = () => {
    switch (mainTabID) {
      case 7:
        return (
          <Grid item xs={12}>
            <BadgeContent />
          </Grid>
        );
      case 6:
        return (
          <Grid item xs={12}>
            <LeftbarAuthClient />
          </Grid>
        );
      case 8:
        return (
          <Grid item xs={5}>
            <LeftSideLeaderboard customStyles={classes.leftbarScroll} />
          </Grid>
        );
      case 9:
        return (
          <Grid item xs={5}>
            <LeftSideInapp customStyles={classes.leftbarScroll} fetchData={fetchInappData} />
          </Grid>
        );
      case 19:
        return (
          <Grid item xs={5}>
            <LeftSideContest customStyles={classes.leftbarScroll} fetchData={fetchContestsData} />
          </Grid>
        );
      default:
        return null;
    }
  };

  const getRightContent = () => {
    switch (mainTabID) {
      case 8:
        return <RightSideLeaderboard />;
      case 9:
        return <RightSideInapp />;
      case 19:
        return <RightSideContest />;
      default:
        return '';
    }
  };

  const getMiddleContent = () => {
    switch (mainTabID) {
      case 10:
        return <CustomGroupMainContent />;
      case 11:
        return <RulesMainContent />;
      case 21:
        return <MainContainer fetchData={fetchRnpList} />;
      case 23:
        return <AdminUsersMainContent />;
      default:
        return '';
    }
  };

  const getContent = () => {
    switch (devTabID) {
      case 0:
        return <MonitorLogsTable />;
      case 1:
        return <ApiMigrations />;
      case 2:
        return (
          <Grid container direction="row" style={{ maxHeight: '91vh' }}>
            <Grid
              item
              style={{
                flexGrow: '0',
                maxWidth: '23%',
                flexBasis: '20%',
                marginRight: '40px',
              }}
            >
              <Grid container direction="column" className={classes.sidebarDose} alignItems="center">
                <Grid item className={classes.tabBar1}>
                  <SidebarMenu type={3} />
                  <SidebarMenu type={4} />
                  <SidebarMenu type={5} />
                  <SidebarMenu type={10} />
                  <SidebarMenu type={12} />
                </Grid>
                {getSearchComponent()}
                {getSidebar()}
              </Grid>
            </Grid>
            <Grid item style={{ flexGrow: '0', maxWidth: '72%', flexBasis: '80%' }}>
              <Grid container direction="column">
                <Grid item className={classes.topbar}>
                  <Topbar />
                </Grid>
                {mainTabID === 6 || mainTabID === 7 || mainTabID === 8 || mainTabID === 9 || mainTabID === 19 ? (
                  <Grid item className={classes.topbar}>
                    <Grid container direction="row">
                      {getLeftContent()}
                      <Grid item xs={7}>
                        {getRightContent()}
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid item className={classes.middleContent}>
                    {getMiddleContent()}
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        );
      case 3:
        return <ZombieTable />;
      case 4:
        return <DealershipListTable />;
      default:
        return null;
    }
  };

  return (
    <div>
      <TopbarMenu />
      {getContent()}
    </div>
  );
};

export default DevPanelLayout;
